import { render, staticRenderFns } from "./pcTabs.vue?vue&type=template&id=35cd0a68&scoped=true"
import script from "./pcTabs.vue?vue&type=script&lang=js"
export * from "./pcTabs.vue?vue&type=script&lang=js"
import style0 from "./pcTabs.vue?vue&type=style&index=0&id=35cd0a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd0a68",
  null
  
)

export default component.exports